<template>
    <ReferralLayout>
        <inertia-head>
            <title>{{$t('referrers.meta_referrer_og:title')}}</title>
            <meta property="og:title" :content="$t('referrers.meta_referrer_og:title')">
            <meta property="og:description" :content="$t('referrers.meta_referrer_og:description')">
            <meta property="og:image" :content="ogHref">
            <meta property="og:url" :content="ogImage">
            <meta property="og:site_name" :content="$t('referrers.meta_referrer_og:site_name')">
            <meta property="og:type" :content="$t('referrers.meta_referrer_og:type')">
        </inertia-head>
        <div>
            <SignUpForm :errors="errors"/>
            <v-row class="my-8">
                <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pr-5">
                    <div class="pb-3 pb-sm-3 pb-md-6 pb-lg-6 pb-xl-6">
                        <div class="font-weight-bold text-h5 d-inline-flex">
                            <div class="rounded-circle bg-info custom_padding mr-3">1</div>
                            <div>{{ $t('referrers.Register to get your unique friends referral code') }}</div>
                        </div>
                        <div class="text-body-1 ml-14 mt-md-4 mt-lg-4 mt-xl-4 mt-2 mt-sm-2">
                            {{ $t('referrers.Tell your circle about the benefits of a solar installation') }}
                        </div>
                    </div>
                    <div class="my-6 my-sm-6 my-md-6 my-lg-6 my-xl-6">
                        <div class="font-weight-bold text-h5 d-inline-flex">
                            <div class="rounded-circle bg-warning-span custom_padding mr-3">2</div>
                            <div>{{ $t('referrers.Tell your friends and family about Nova') }} </div>
                        </div>
                        <div class="text-body-1 ml-14 mt-md-4 mt-lg-4 mt-xl-4 mt-2 mt-sm-2">
                            {{ $t('referrers.Tell your circle about the benefits') }}
                        </div>
                    </div>
                    <div class="pt-3 pt-sm-3 pt-md-6 pt-lg-6 pt-xl-6">
                        <div class="font-weight-bold text-h5 position-relative d-inline-flex">
                            <div class="rounded-circle bg-success custom_padding mr-3 custom_point">3</div>
                            <div>{{ $t('referrers.Get paid') }}</div>
                        </div>
                        <div class="text-body-1 ml-14 mt-md-4 mt-lg-4 mt-xl-4 mt-2 mt-sm-2">
                            {{ $t('referrers.Once the panels are on the roof') }}
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pl-5">
                    <v-card color="success" class="rounded-card mb-7" flat>
                        <v-card-text class="px-5 pb-0">
                            <div class="font-weight-bold text-h5">
                                {{ $t('referrers.Keep track of all your friends') }}
                            </div>
                            <div class="text-body-1 font-weight-medium mt-4 mb-6">
                                {{ $t('referrers.Your personal account will allow you to share') }}
                            </div>
                            <v-card color="white" class="rounded-card pt-2 pb-6">
                                <v-card-text class="px-5 py-2">
                                    <div class="text-caption font-weight-bold">{{ $t('referrers.Your code') }}</div>
                                    <div class="border">
                                        <v-icon icon="mdi-link-variant" size="13" class="ma-1"></v-icon>
                                        <v-chip size="x-small" density="compact" class="px-11 pt-2 pb-1"></v-chip>
                                        <v-btn size="extra-small" class="text-small py-1 px-2 ma-1 text-capitalize" color="primary">{{ $t('referrers.Copy link') }}</v-btn>
                                    </div>
                                    <div class="text-caption font-weight-bold mt-2">{{ $t('referrers.Your referrals') }} </div>
                                    <v-row no-gutters align="center">
                                        <v-col cols="5">
                                            <div class="text-small text-uppercase text-info font-weight-bold">{{ $t('referrers.name') }}</div>
                                        </v-col>
                                        <v-col cols="3" class="text-center">
                                            <div class="text-small text-uppercase text-info font-weight-bold">{{ $t('referrers.quote') }}</div>
                                        </v-col>
                                        <v-col cols="4" class="text-center">
                                            <div class="text-small text-uppercase text-info font-weight-bold">{{ $t('referrers.installed') }}</div>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-chip size="x-small" density="compact" class="px-8 pt-2 pb-1 my-2"></v-chip>
                                        </v-col>
                                        <v-col cols="3" class="text-center"> <v-icon size="7" icon="mdi-check-bold" color="success"></v-icon></v-col>
                                        <v-col cols="4" class="text-center"> <v-icon size="7" icon="mdi-check-bold" color="success"></v-icon></v-col>
                                        <v-col cols="12"> <v-divider/></v-col>
                                        <v-col cols="5">
                                            <v-chip size="x-small" density="compact" class="px-6 pt-2 pb-1 my-2"></v-chip>
                                        </v-col>
                                        <v-col cols="3" class="text-center"> <v-icon size="7" icon="mdi-check-bold" color="success"></v-icon></v-col>
                                        <v-col cols="4" class="text-center"></v-col>
                                        <v-col cols="12"> <v-divider/></v-col>
                                        <v-col cols="5">
                                            <v-chip size="x-small" density="compact" class="px-9 pt-2 pb-1 my-2"></v-chip>
                                        </v-col>
                                        <v-col cols="3" class="text-center"><v-icon size="7" icon="mdi-check-bold" color="success"></v-icon></v-col>
                                        <v-col cols="4" class="text-center"><v-icon size="7" icon="mdi-check-bold" color="success"></v-icon></v-col>
                                        <v-col cols="12"> <v-divider/></v-col>
                                    </v-row>
                                    <div class="text-caption font-weight-bold mt-2">{{ $t('referrers.Payouts') }}</div>
                                    <v-row justify="space-between" no-gutters>
                                        <v-col cols="5">
                                            <div class="text-small text-uppercase text-info font-weight-bold">{{ $t('referrers.month') }}</div>
                                        </v-col>
                                        <v-col cols="3">
                                            <div class="text-small text-uppercase text-info font-weight-bold">{{ $t('referrers.payout') }}</div>
                                        </v-col>
                                        <v-col cols="5" >
                                            <v-chip size="x-small" density="compact" class="px-8 pt-2 pb-1 my-2"></v-chip>
                                        </v-col>
                                        <v-col cols="3">
                                            <div class="text-small text-uppercase font-weight-bold">{{ $t('referrers.Promo payout') }}</div>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-divider/>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </ReferralLayout>
</template>

<script>
import SignUpForm from "../../Components/ReferralCampaigns/signUp/SignUpForm";
import ReferralLayout from "../../Layouts/ReferralLayout";

export default {
    name: "SignUp",
    components: {
        SignUpForm,
        ReferralLayout,
    },
    props: {
        errors: {
            type: Object,
            required: false,
        },
    },
    computed: {
        ogHref() {
            return window.location.href;
        },
        ogImage() {
            return window.location.origin + "/img/og-image.jpg"
        }
    }

}
</script>

<style scoped>
.rounded-card {
    border-radius: 12px;
    margin-bottom: -30px;
    z-index: 10;
}
.text-small {
    font-size: 8px;
}
.bg-warning-span {
    background: #F6C407;
    color: #fff;
}
.custom_point:before{
    content: url("/img/referral/beams.svg");
    position: absolute;
    top: -22px;
    width: 44px;
    left: -1px;
}
.custom_padding {
    width: 40px;
    height: 40px;
    display: grid;
    justify-content: center;
    align-content: center;
    flex: none;
}
</style>
